module.exports = require("lodash/isPlainObject");;